import { Color3, type Mesh, MeshBuilder, type Scene, StandardMaterial } from "@babylonjs/core";
import type { PlotInfo } from "../net/api";

/** A faint warm pillar over the player's own estate, visible through the fog (spec 2d §4.7). */
export class EstateBeam {
  private readonly mesh: Mesh;
  private bounds: PlotInfo["bounds"] | null = null;

  constructor(scene: Scene, private readonly height: (x: number, z: number) => number) {
    this.mesh = MeshBuilder.CreateCylinder("estate:beam", { diameter: 0.8, height: 40, tessellation: 12 }, scene);
    const m = new StandardMaterial("estate:beam", scene);
    m.emissiveColor = Color3.FromHexString("#ffd59a");
    m.diffuseColor = Color3.Black();
    m.specularColor = Color3.Black();
    m.disableLighting = true;
    m.alpha = 0.35;
    this.mesh.material = m;
    this.mesh.applyFog = false;
    this.mesh.isPickable = false;
    this.mesh.setEnabled(false);
  }

  setEstate(plot: Pick<PlotInfo, "bounds"> | null): void {
    this.bounds = plot?.bounds ?? null;
    if (!this.bounds) { this.mesh.setEnabled(false); return; }
    const cx = (this.bounds.min[0] + this.bounds.max[0]) / 2, cz = (this.bounds.min[1] + this.bounds.max[1]) / 2;
    this.mesh.position.set(cx, this.height(cx, cz) + 20, cz);
  }

  update(x: number, z: number): void {
    const b = this.bounds;
    const inside = !!b && x >= b.min[0] && x < b.max[0] && z >= b.min[1] && z < b.max[1];
    this.mesh.setEnabled(!!b && !inside);
  }
}
